module.exports = __webpack_public_path__ + "img/phuong_nguyen.18cadbc8.jpg";